import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, withCtx as _withCtx, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ace62a46"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "password-field" }
const _hoisted_2 = { class: "popover-content" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Требования к паролю", -1))
const _hoisted_4 = { class: "password-info" }
const _hoisted_5 = { class: "password-item" }
const _hoisted_6 = { class: "password-item" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Строчные латинские буквы", -1))
const _hoisted_8 = { class: "password-item" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Заглавные латинские буквы", -1))
const _hoisted_10 = { class: "password-item" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Цифры", -1))
const _hoisted_12 = { class: "password-item" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Спецсимволы", -1))
const _hoisted_14 = { class: "strength-bar" }
const _hoisted_15 = {
  key: 0,
  class: "text--small text--center error--text mt-2 error-message"
}
const _hoisted_16 = { class: "mt-6 text--center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InfoCircleFilled = _resolveComponent("InfoCircleFilled")!
  const _component_UiPopover = _resolveComponent("UiPopover")!
  const _component_UiInput = _resolveComponent("UiInput")!
  const _component_UiProgress = _resolveComponent("UiProgress")!
  const _component_UiButton = _resolveComponent("UiButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_UiInput, {
      modelValue: _ctx.password,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.password) = $event)),
      type: _ctx.showPassword ? 'text' : 'password',
      placeholder: "Пароль",
      disabled: _ctx.isPinTimeOver || _ctx.isRequestInProgress,
      status: _ctx.validations.password.$invalid ? 'error' : undefined,
      onFocus: _ctx.onFocus
    }, {
      suffix: _withCtx(() => [
        _createElementVNode("span", {
          class: "eye-icon",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showPassword = !_ctx.showPassword))
        }, [
          (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.showPassword ? _ctx.EyeInvisibleFilled : _ctx.EyeFilled)))
        ]),
        _createVNode(_component_UiPopover, {
          trigger: "hover",
          color: "#000000d9"
        }, {
          content: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _hoisted_3,
              _createElementVNode("ul", _hoisted_4, [
                _createElementVNode("li", _hoisted_5, [
                  _createElementVNode("span", {
                    class: "dot",
                    style: _normalizeStyle(_ctx.ruleStyle('lengthValid'))
                  }, null, 4),
                  _createElementVNode("span", null, "Минимум " + _toDisplayString(_ctx.MIN_LENGTH) + " символов", 1)
                ]),
                _createElementVNode("li", _hoisted_6, [
                  _createElementVNode("span", {
                    class: "dot",
                    style: _normalizeStyle(_ctx.ruleStyle('lowercase'))
                  }, null, 4),
                  _hoisted_7
                ]),
                _createElementVNode("li", _hoisted_8, [
                  _createElementVNode("span", {
                    class: "dot",
                    style: _normalizeStyle(_ctx.ruleStyle('uppercase'))
                  }, null, 4),
                  _hoisted_9
                ]),
                _createElementVNode("li", _hoisted_10, [
                  _createElementVNode("span", {
                    class: "dot",
                    style: _normalizeStyle(_ctx.ruleStyle('digit'))
                  }, null, 4),
                  _hoisted_11
                ]),
                _createElementVNode("li", _hoisted_12, [
                  _createElementVNode("span", {
                    class: "dot",
                    style: _normalizeStyle(_ctx.ruleStyle('symbol'))
                  }, null, 4),
                  _hoisted_13
                ])
              ])
            ])
          ]),
          default: _withCtx(() => [
            _createVNode(_component_InfoCircleFilled)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue", "type", "disabled", "status", "onFocus"]),
    _createElementVNode("div", _hoisted_14, [
      _createVNode(_component_UiProgress, {
        showInfo: false,
        percent: _ctx.passwordStrength.percent,
        strokeColor: _ctx.passwordStrength.color,
        status: _ctx.passwordStrength.status,
        size: 8
      }, null, 8, ["percent", "strokeColor", "status"]),
      _createElementVNode("span", {
        style: _normalizeStyle({ color: _ctx.passwordStrength.color, fontSize: '14px' })
      }, _toDisplayString(_ctx.passwordStrength.label), 5)
    ]),
    _createVNode(_component_UiInput, {
      modelValue: _ctx.passwordConfirm,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.passwordConfirm) = $event)),
      class: "mt-4",
      placeholder: "Подтвердите пароль",
      type: _ctx.showPasswordConfirm ? 'text' : 'password',
      disabled: _ctx.isPinTimeOver || _ctx.isRequestInProgress,
      status: _ctx.validations.passwordConfirm.$invalid ? 'error' : undefined
    }, {
      suffix: _withCtx(() => [
        _createElementVNode("span", {
          class: "eye-icon",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showPasswordConfirm = !_ctx.showPasswordConfirm))
        }, [
          (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.showPasswordConfirm ? _ctx.EyeInvisibleFilled : _ctx.EyeFilled)))
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "type", "disabled", "status"]),
    (_ctx.isPinTimeOver || !!_ctx.errorMessage || _ctx.validations.$invalid)
      ? (_openBlock(), _createElementBlock("p", _hoisted_15, _toDisplayString(_ctx.firstError), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_16, [
      _createVNode(_component_UiButton, {
        class: "button-submit",
        type: "primary",
        size: "large",
        disabled: _ctx.isFormInvalid,
        onClick: _ctx.execute
      }, {
        default: _withCtx(() => [
          _createTextVNode(" Создать новый пароль ")
        ]),
        _: 1
      }, 8, ["disabled", "onClick"]),
      _createVNode(_component_UiButton, {
        type: "link",
        size: "large",
        onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.$emit('goToLogin')), ["prevent","stop"]))
      }, {
        default: _withCtx(() => [
          _createTextVNode("На страницу входа")
        ]),
        _: 1
      })
    ])
  ]))
}